// @ts-nocheck
import React, { useCallback } from 'react';
import { Input } from 'antd';
import { FilterItem } from '../../../../components';
import Field from '../../../../components/card/Field';
import { CommonFilter } from '../../../../components/hoc/common/handbook/CommonFilter';
export const PddTicketFilter = props => {
  const Filter = useCallback(filterProps => CommonFilter({
    ...filterProps,
    ...props
  }), [props]);
  return <Filter>
      {(values, changeValue) => <>
          <FilterItem>
            <Field mBottomNone>
              <Input size="small" value={values.search} onChange={e => changeValue('search', e.target.value)} placeholder="Наименование" />
            </Field>
          </FilterItem>
        </>}
    </Filter>;
};
export default PddTicketFilter;
